<template>
  <div class="lawjqqy">
    <div class="wdl" v-if="!istoken">
      需要律师用户登录后才可接洽案件！<span class="login">点此登录</span>
    </div>
    <div class="ydljq" v-if="istoken">
      <div class="jqheader">
        接洽案件仅律观网加盟会员才能接洽 <span>加盟律观网</span>
      </div>
      <div class="jqhdcon">
        <textarea></textarea>
      </div>
      <div class="jqbtn">提交回答</div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    istoken() {
      return this.$store.state.user.token;
    },
  },
};
</script>

<style lang="scss" scoped>
.lawjqqy {
  padding: 20px 34px;
  .wdl {
    font-size: 18px;
    color: #666666;
    .login {
      cursor: pointer;
      color: #0465ea;
    }
  }
  .ydljq {
    .jqheader {
      font-size: 18px;
      color: #666666;
      span {
        margin-left: 45px;
        color: #0465ea;
        cursor: pointer;
      }
    }
    .jqhdcon {
      margin-top: 15px;
      textarea {
        width: 100%;
        height: 180px;
        background: #ffffff;
        border: 1px solid #dddddd;
        padding: 10px;
        font-size: 16px;
        color: #333;
        line-height: 24px;
      }
    }
    .jqbtn {
      width: 170px;
      text-align: center;
      height: 40px;
      line-height: 40px;
      margin-top: 10px;
      font-size: 18px;
      color: #ffffff;
      background: #258bf9;
    }
  }
}
</style>